/**
 * What counts as a picture, on the client side of the review.
 *
 * A detection's frame arrives in one of two forms, and the difference decides what may be sent
 * back: a CAPTURE is image bytes, which the server stores, while everything else is a LINK to a
 * frame already in storage (a SAS URL the server minted, display-only and expiring).
 *
 * Sending a link where the server expects bytes is not harmless: it reads as "a new capture",
 * which clears the stored file name and orphans the image with nothing to put in its place.
 */

/** A capture carries its bytes inline; anything else is a link to a frame stored elsewhere. */
export const isDataUrl = (value?: string): boolean => !!value && value.startsWith("data:");
